var React = require('react');

function IconArrowHalfInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"m15.68 18-1.36.62A13.09 13.09 0 0 0 8 12.31 13.18 13.18 0 0 0 14.36 6l1.36.62a14.08 14.08 0 0 1-5.59 5.69c.367.19.72.404 1.06.64A14.54 14.54 0 0 1 15.68 18z","fill":"#000","fillRule":"nonzero","key":1})]));
}

IconArrowHalfInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconArrowHalfInline;

IconArrowHalfInline.default = IconArrowHalfInline;
